<template>
  <div class="description" :class="colorClass">
    <span class="desc">
      {{ desc }}
    </span>
    <span class="title">{{ i18n('description', 'title') }}</span>
    <div class="risk-container" v-if="availableParams.model.includes('hospitalization')">
      <font-awesome-icon class="icon" icon="hospital" />
      <span class="label">{{ i18n('description', 'hospitalization') }}</span>
      <span class="risk">{{ risks.hospitalization | formatRisk }}</span>
    </div>
    <div class="risk-container" v-if="availableParams.model.includes('severe')">
      <font-awesome-icon class="icon" icon="hospital" />
      <span class="label">{{ i18n('description', 'severe') }}</span>
      <span class="risk">{{ risks.severe | formatRisk }}</span>
    </div>
    <div class="risk-container" v-if="availableParams.model.includes('death')">
      <font-awesome-icon class="icon" icon="hourglass-end" />
      <span class="label">{{ i18n('description', 'death') }}</span>
      <span class="risk">{{ risks.death | formatRisk }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import format from '@/utils/format.js'

/* eslint-disable arena/no-hardcode-param-types */
export default {
  name: 'Description',
  data () {
    return {
      attributes: null
    }
  },
  watch: {
    label: {
      handler: 'loadAttributes',
      immediate: true
    }
  },
  filters: {
    formatTitle: format.formatTitle,
    firstCharUpper: format.firstCharUpper,
    formatRisk: (v) => {
      if (v === undefined) return ''
      return (Math.round(v * 100 * 100) / 100) + '%'
    }
  },
  computed: {
    colorClass () {
      let maxRisk = Math.max(...Object.values(this.risks), 0)
      let cls = maxRisk > 0.5 ? 'bad' : (maxRisk > 0.2 ? 'danger' : 'good')
      return { [cls]: true }
    },
    label () {
      return this.getGlobalParam('observation')
    },
    variables () {
      if (!this.attributes) return []
      return Object.keys(this.attributes).filter(k => !k.startsWith('predict_'))
    },
    desc () {
      return this.variables.filter(k => (typeof this.attributes[k]) !== 'boolean' || this.attributes[k]).map(v => {
        let valuePart = ': ' + this.i18n('variableValues', this.attributes[v])
        if ((typeof this.attributes[v]) === 'boolean') {
          valuePart = ''
        }
        return format.firstCharUpper(format.formatTitle(this.i18n('variable', v))) + valuePart
      }).join(', ')
    },
    risks () {
      if (!this.attributes) return {}
      return Object.keys(this.attributes).filter(k => k.startsWith('predict_')).reduce((acu, key) => {
        acu[key.substr(8)] = this.attributes[key]
        return acu
      }, {})
    },
    ...mapGetters(['getGlobalParam', 'i18n', 'availableParams'])
  },
  methods: {
    loadAttributes () {
      let attributes = this.attributes
      if (!this.label) return
      this.$store.dispatch('getAttributes', { paramType: 'observation', paramValue: this.label }).then(x => {
        if (!x || this.attributes !== attributes) return
        this.attributes = x
      }).catch(this.clear)
    },
    clear () {
      this.attributes = null
    }
  },
  components: {}
}
</script>
<style>
div.description.good {
  background: #8bdcbe;
  color: #160e3b;
}
div.description.bad {
  background: #f05a71;
  color: white;
}
div.description.danger {
  background: #ffa58c;
  color: #160e3b;
}
div.description {
  padding: 30px;
  margin: 30px;
  width: calc(100% - 120px);
  margin-bottom: 0;
}
div.description > span.title {
  font-size: 24px;
  display: block;
  margin-bottom: 20px;
}
div.description > span.desc {
  font-size: 22px;
  display: block;
  margin-bottom: 10px;
  margin-top: -10px;
}
div.description > div.risk-container {
  display: inline-block;
  margin: 15px;
  position: relative;
  height: 80px;
  width: 400px;
}
div.description > div.risk-container > .icon {
  font-size: 60px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
div.description > div.risk-container > .label {
  font-size: 24px;
  margin-left: 70px;
  font-family: 'FiraSansBold';
}
div.description > div.risk-container > .risk {
  position: absolute;
  left: 70px;
  bottom: 0;
  font-size: 40px;
}
</style>
